import { render, staticRenderFns } from "./Rappels.vue?vue&type=template&id=64405f32&scoped=true"
import script from "./Rappels.vue?vue&type=script&lang=js"
export * from "./Rappels.vue?vue&type=script&lang=js"
import style0 from "./Rappels.vue?vue&type=style&index=0&id=64405f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64405f32",
  null
  
)

export default component.exports